import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import DailyPicks from './pages/DailyPicks';
import TopTrades from './pages/TopTrades';
import SearchPage from './pages/SearchPage';
import ChartPage from './pages/ChartPage';
import Disclaimer from "./pages/Disclaimer";
import "./styles/tailwind.css";
import AllNysePicks from "./pages/AllNysePicks";
import AdminTools from "./pages/AdminTools";
import CryptoPage from "./pages/CryptoPage";
import { AuthProvider } from "./context/AuthContext";
import RequireAuth from "./components/RequireAuth";
import Login from "./pages/Login";
import Register from "./pages/Register"
import Pricing from "./pages/Pricing";
import RequirePro from "./components/RequirePro";
import ShortSqueezes from "./pages/ShortSqueezes";
import HowToUse from "./pages/HowToUse";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ParabolicBreakouts from "./pages/ParabolicBreakouts";
import PaperTrading from "./pages/PaperTrading";
import OptionsSearchPage from "./pages/OptionsSearch";
import AdminAutoTrades from "./pages/AdminAutoTrades";
import DividendTracker from "./pages/DividendTracker";
import EarningsPredictor from "./pages/EarningsPredictor";
import BotPage from "./pages/BotPage";
    

function App() {
    return (
        <div className="flex min-h-screen bg-gray-900 text-white">
                <Router>
                    <Sidebar />
                    <main className="flex-1 p-4 overflow-y-auto">
                        <Routes>
                            {/* Public pages */}
                            <Route path="/" element={<DailyPicks />} />
                            <Route path="/chart/:ticker" element={<ChartPage />} />
                            <Route path="/disclaimer" element={<Disclaimer />} />
                            <Route path="/how-to-use" element={<HowToUse />} />
                            {/* Auth */}
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/forgot" element={<ForgotPassword />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            {/* Stripe */}
                            <Route path="/pricing" element={<Pricing />} />

                            {/* Protected pages */}
                            <Route path="/top-trades" element={<RequirePro> <TopTrades /> </RequirePro>} />
                            <Route path="/all-nyse-picks" element={<RequirePro> <AllNysePicks /> </RequirePro>} />
                            <Route path="/crypto-trades" element={<RequirePro> <CryptoPage /> </RequirePro>} />
                            <Route path="/search" element={<RequirePro> <SearchPage /> </RequirePro>} />
                            <Route path="/short-squeezes" element={<RequirePro> <ShortSqueezes /> </RequirePro>} />
                            <Route path="/parabolic-breakouts" element={<RequirePro> <ParabolicBreakouts /> </RequirePro>} />
                            <Route path="/paper-live-trading" element={<RequirePro> <PaperTrading /> </RequirePro>} />
                            <Route path="/options-search" element={<RequirePro> <OptionsSearchPage /> </RequirePro>} />
                            <Route path="/dividend-tracker" element={<RequirePro> <DividendTracker /> </RequirePro>} />
                            <Route path="/earnings-predictor" element={<RequirePro><EarningsPredictor /></RequirePro>} />
                            <Route path="/bot" element={<RequirePro><BotPage /></RequirePro>} />


                            {/* Admin (Switch from RequirePro to RequireAuth if you want login-only) */}
                            <Route path="/admin" element={<RequireAuth> <AdminTools /> </RequireAuth>} />
                            <Route path="/admin/auto-trades" element={<RequireAuth><AdminAutoTrades /></RequireAuth>} />

                        </Routes>
                    </main>
                </Router>
        </div>
    );
}

export default App;
